import { z } from 'zod';
/**
 * Counterparty verification — what goes in, and what comes back.
 *
 * The checks themselves live in the API's verification engine, which is
 * deliberately untyped JavaScript lifted whole from the standalone Verification
 * Desk. These declarations are the contract between it and everything else: the
 * router validates against the schemas, and the employee portal renders the
 * result types. Both halves read this file, so the report cannot drift from the
 * page that shows it.
 *
 * Nothing here is stored. A check is a question asked of the open web and
 * answered in the moment; run it again next month and the answer may differ,
 * which is exactly why a saved verdict would be worse than no verdict.
 */
/** Anything you can hand the desk to start with. */
export const verificationCandidatesSchema = z.object({
    name: z.string().trim().min(2, 'Give the business name.').max(120),
    /**
     * The city, if the person knows it. Not required, and not trusted: it orders
     * the candidates and is checked against what the search actually found, so
     * asking for Bengaluru and finding only Raipur stops rather than answers.
     */
    city: z.string().trim().max(80).optional(),
});
/**
 * Which of several businesses sharing a name the report is about.
 *
 * Every later page is filtered against this. Left empty, the desk reads
 * everything it found, which is right for a name only one business holds and
 * wrong the moment two do.
 */
export const verificationScopeSchema = z.object({
    place: z.string().trim().max(80).optional(),
    host: z.string().trim().max(200).optional(),
    gstin: z.string().trim().max(20).optional(),
    cin: z.string().trim().max(30).optional(),
    label: z.string().trim().max(160).optional(),
});
export const verificationEvidenceSchema = z.object({
    name: z.string().trim().min(2, 'Give the business name.').max(120),
    city: z.string().trim().max(80).optional(),
    gstin: z.string().trim().max(20).optional(),
    cin: z.string().trim().max(30).optional(),
    website: z.string().trim().url('That is not a URL.').max(300).optional(),
    scope: verificationScopeSchema.optional(),
});
//# sourceMappingURL=verification.schema.js.map